/* 
 * Copyright (C) Patient10x (https://www.patient10x.com) - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { Icon } from '@blueprintjs/core';
import { HTMLAttributes, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useIdentity } from 'auth/auth.hooks';
import { Button } from 'common/components';
import { useAppState } from 'common/utils';
import { GetCustomerPortalLink } from 'subscription/actions/get-customer-portal-link.action';
import styles from "./styles.module.scss";


export default function ({
  className, portalLinkUrl, buttonText, ...rest
}: ManageSubscriptionProps) {
  const { t } = useTranslation();
  const identity = useIdentity();
  const classes = useMemo(() => [styles.manageSubscription, className].join(" "), [className]);

  const [getCustomerPortalLinkState, dispatch] = useAppState((store) => store.subscription.getCustomerPortalLink);

  const getCustomerPortalLink = useCallback(() => {
    dispatch(GetCustomerPortalLink(window.location.href))
  }, []);

  useMemo(() => {
    if (portalLinkUrl == null)
      getCustomerPortalLink();
  }, [identity?.subscription, portalLinkUrl])

  return identity?.subscription == null ? null : (
    <div className={classes} {...rest}>
      <img
        className="logo"
        src={`/static/images/subscription_plan_${identity.subscription.plan}.png`}
        alt="logo"
      />
      <h2>{t(`Subscription.Names.${identity.subscription.plan}`)}</h2>
      <span>
        {t(`Subscription.Descriptions.${identity.subscription.plan}`)}
      </span>
      <p>This includes:</p>
      <p>
        <Icon icon="tick-circle" color='grey' size={12} />
        {t("Subscription.MaxActiveDomains", { count: identity.subscription.quota.maxActiveDomains })}
      </p>
      <p>
        <Icon icon="tick-circle" color='grey' size={12} />
        Unlimited Widgets
      </p>
      <p>
        <Icon icon="tick-circle" color='grey' size={12} />
        {t("Subscription.TotalWidgetViews", { count: identity.subscription.quota.totalWidgetViews })}
      </p>
      <p>
        <Icon icon="tick-circle" color='grey' size={12} />
        {t(`Subscription.Vibes.${identity.subscription.plan}`)}
      </p>
      <Button
        fill
        intent='warning'
        text={buttonText || "Manage"}
        disabled={!portalLinkUrl && !getCustomerPortalLinkState.value}
        loading={getCustomerPortalLinkState.isLoading}
        onClick={() => window.open(portalLinkUrl || getCustomerPortalLinkState.value!, "_self")}
      />
    </div>
  );
}

export type ManageSubscriptionProps = HTMLAttributes<HTMLDivElement> & {
  className?: string;
  portalLinkUrl?: string;
  buttonText?: string;
};